import React from "react";

const BASE = "/assets/image/home/trust-badges";

const badges = [
    {
        id: "shopify",
        logo: `${BASE}/logo-shopify.svg`,
        logoAlt: "Shopify logo",
        lines: ["Trusted Shopify", "Solutions Partner"],
    },
    {
        id: "dribbble",
        logo: `${BASE}/logo-dribbble.svg`,
        logoAlt: "Dribbble logo",
        lines: ["Featured Since 2021", "25K+ Followers"],
        alignCenter: true,
    },
    {
        id: "upwork",
        logo: `${BASE}/logo-upwork.svg`,
        logoAlt: "Upwork logo",
        lines: ["Top Rated Plus Agency", "100% Success Rate"],
    },
    {
        id: "clutch",
        logo: `${BASE}/logo-clutch.svg`,
        logoAlt: "Clutch logo",
        lines: ["Verified 5 Star", "Client Reviews"],
    },
];

const Laurel = ({ side }) => {
    const isLeft = side === "left";
    return (
        <div
            className={`tw:relative tw:shrink-0 tw:w-[20px] tw:h-[36px] tw:lg:w-[26px] tw:lg:h-[46px] tw:1xl:w-[35px] tw:1xl:h-[62px] ${isLeft ? "tw:flex tw:items-center tw:justify-center" : ""
                }`}
        >
            <div className={`tw:size-full ${isLeft ? "tw:-scale-y-100 tw:rotate-180 tw:flex-none" : ""}`}>
                <img
                    src={isLeft ? `${BASE}/laurel-left.svg` : `${BASE}/laurel-right.svg`}
                    alt=""
                    width={35}
                    height={62}
                    className="tw:block tw:max-w-none tw:size-full tw:user-select-none tw:pointer-events-none tw:select-none"
                    loading="lazy"
                    decoding="async"
                    aria-hidden="true"
                />
            </div>
        </div>
    );
};

const Stars = () => (
    <div className="tw:flex tw:w-full tw:items-center tw:justify-center tw:gap-px" aria-label="5 out of 5 stars">
        {Array.from({ length: 5 }).map((_, i) => (
            <span
                key={i}
                className="tw:relative tw:size-[9px] tw:shrink-0 tw:overflow-clip tw:lg:size-[11px] tw:1xl:size-[14px]"
            >
                <span className="tw:absolute tw:inset-[5.21%]">
                    <img
                        src={`${BASE}/star.svg`}
                        alt=""
                        width={13}
                        height={13}
                        className="tw:absolute tw:inset-0 tw:block tw:size-full tw:max-w-none tw:user-select-none tw:pointer-events-none tw:select-none"
                        loading="lazy"
                        decoding="async"
                        aria-hidden="true"
                    />
                </span>
            </span>
        ))}
    </div>
);

const TrustBadge = ({ logo, logoAlt, lines, alignCenter }) => (
    <div className="tw:flex tw:shrink-0 tw:flex-col tw:items-center tw:gap-2.5 tw:lg:gap-3 tw:1xl:gap-5">
        <div
            className={`tw:flex tw:gap-1.5 tw:lg:gap-2 tw:1xl:gap-3 ${alignCenter ? "tw:items-center" : "tw:items-start"
                }`}
        >
            <Laurel side="left" />
            <div className="tw:flex tw:shrink-0 tw:flex-col tw:items-center tw:gap-1 tw:lg:gap-1.5 tw:1xl:gap-[7px]">
                <div className="tw:relative tw:h-[24px] tw:w-[86px] tw:shrink-0 tw:lg:h-[30px] tw:lg:w-[108px] tw:1xl:h-[40px] tw:1xl:w-[144px]">
                    <img
                        src={logo}
                        alt={logoAlt}
                        width={144}
                        height={40}
                        className="tw:absolute tw:inset-0 tw:block tw:size-full tw:max-w-none tw:user-select-none tw:pointer-events-none tw:select-none"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
                <Stars />
            </div>
            <Laurel side="right" />
        </div>
        <p className="tw:m-0 tw:w-min tw:min-w-full tw:text-center tw:text-[9px] tw:font-medium tw:uppercase tw:leading-normal tw:tracking-[0.8px] tw:text-white tw:lg:text-[10px] tw:lg:tracking-[1px] tw:1xl:text-[12px] tw:1xl:tracking-[1.2px]">
            {lines[0]}
            <br />
            {lines[1]}
        </p>
    </div>
);

/** Shared trust badge row — Shopify, Dribbble, Upwork, Clutch */
export default function TrustBadges({ className = "" }) {
    return (
        <div
            className={`tw:grid tw:w-full tw:grid-cols-2 tw:gap-x-6 tw:gap-y-8 tw:sm:gap-x-8 tw:sm:gap-y-10 tw:lg:flex tw:lg:flex-wrap tw:lg:items-start tw:lg:justify-center tw:lg:gap-x-12 tw:xl:gap-x-16 tw:1xl:gap-x-[100px] tw:1xl:gap-y-10 ${className}`.trim()}
            role="list"
            aria-label="Partner ratings"
        >
            {badges.map((badge) => (
                <div key={badge.id} role="listitem" className="tw:flex tw:justify-center">
                    <TrustBadge {...badge} />
                </div>
            ))}
        </div>
    );
}